import { APPOINTMENT_STATUS_CLEAR } from '../constants/appointmentStatusTypes';

export function appointmentStatusClear() {
  return { type: APPOINTMENT_STATUS_CLEAR };
}



// WEBPACK FOOTER //
// ./app/actions/appointmentStatusActions.js